import { useState } from 'react';
import { getDefaultLanguage } from '../utils/browser';

export default function useUser() {
  const defaultLanguage = getDefaultLanguage();

  const emptyUser = {
    status: null,
    language: defaultLanguage.id,
    role: null,
    external: false,
    realmId: null,
    authHost: null,
    authenticated: false,
    legalAccepted: false,
    openLegal: false,
  };

  const getUser = () => {
    const userString = localStorage.getItem('user');
    if (userString && userString !== 'null') {
      const user = JSON.parse(userString);
      user.language ??= defaultLanguage.id;
      return user;
    }
    return emptyUser;
  };

  const [user, setUser] = useState(getUser());

  const saveUser = (userData = emptyUser) => {
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  return {
    setUser: saveUser,
    user,
    emptyUser,
  };
}
